import React from 'react'
import { connect } from 'react-redux'

import { Modal } from '@material-ui/core'
import { ActionCreator } from 'redux'
import { ModalCard } from '../../components'
import { createUserEnd } from '../../state/SystemCache/actions'
import { getCreateUser } from '../../state/SystemCache/selectors'
import { State } from '../../types'
import CreateUserFormContainer from './CreateUserForm'

type Props = {
  createUser: { editing: boolean }
  handleModalClose: ActionCreator<void>
}

function CreateUserFormModal(props: Props) {
  return (
    <Modal open={props.createUser.editing} onClose={props.handleModalClose}>
      <ModalCard>
        <CreateUserFormContainer />
      </ModalCard>
    </Modal>
  )
}

type OProps = {}

const conn = connect(
  (state: State, _op: OProps) => ({
    createUser: getCreateUser(state),
  }),
  {
    handleModalClose: createUserEnd,
  },
)

const CreateUserFormModalContainer = conn(CreateUserFormModal)

export default CreateUserFormModalContainer
